export default __webpack_public_path__ + "static/media/m_quiz_bg_1.afd000ce.png";